import { Component, OnInit } from '@angular/core';

import { CalculationService } from '../calculation.service';

@Component({
  selector: 'app-amort-form',
  templateUrl: './amort-form.component.html',
  styleUrls: ['./amort-form.component.css']
})
export class AmortFormComponent implements OnInit {
  hide = true;
  errorInfo = true;
  errorMessage;
  loanValue;
  downPayment;
  interestRate;
  loanTerm;

  constructor(private calcService: CalculationService) { }

  ngOnInit() {
    this.calcService.dataToEmit.subscribe(
      (dataFromForm: {
        hide: boolean, loanValue: number, downPayment: number, interestRate: number,
        loanTerm: number
      }) => {
        this.hide = dataFromForm.hide;
        this.loanValue = dataFromForm.loanValue;
        this.downPayment = dataFromForm.downPayment;
        this.interestRate = dataFromForm.interestRate;
        this.loanTerm = dataFromForm.loanTerm;
      }
    );
  }

  sendFormData() {
    if (this.loanValue == null) {
      this.errorInfo = false;
      this.errorMessage = ('Mortgage / Loan value can not be less than ( 100 ) Hundred or " LEFT EMPTY ! "');
    } else if (this.loanValue === '') {
      this.errorInfo = false;
      this.errorMessage = ('Mortgage / Loan value can not be less than ( 100 ) Hundred or " LEFT EMPTY ! "');
    } else if (!Number.isInteger(Number(this.loanValue))) {
      this.errorInfo = false;
      this.errorMessage = ('Please enter only whole numbers between ( 100 to 100 Billion ) in " TOTAL MORTGAGE / LOAN VALUE " field.');
    } else if (this.loanValue < 100) {
      this.errorInfo = false;
      this.errorMessage = ('Mortgage / Loan value can not be less than ( 100 ) Hundred or " LEFT EMPTY ! "');
    } else if (this.loanValue > 100000000000) {
      this.errorInfo = false;
      this.errorMessage = ('Mortgage / Loan value can not be more than ( 100,000,000,000 ) Hundred Billion.');
    } else if (this.downPayment == null) {  // DOWN PAYMENT VALIDATION
      this.errorInfo = false;
      this.errorMessage = ('Down payment can not be less than ( 0 ) Zero or " LEFT EMPTY !"');
    } else if (this.downPayment === '') {
      this.errorInfo = false;
      this.errorMessage = ('Down payment can not be less than ( 0 ) Zero or " LEFT EMPTY !"');
    } else if (isNaN(this.downPayment)) {
      this.errorInfo = false;
      this.errorMessage = ('Please enter only numbers from ( 0 to 90 ) in " DOWN PAYMENT " field.');
    } else if (this.downPayment === '-0') {
      this.errorInfo = false;
      this.errorMessage = ('Down payment can not be less than ( 0 ) Zero or " LEFT EMPTY !"');
    } else if (this.downPayment < 0) {
      this.errorInfo = false;
      this.errorMessage = ('Down payment can not be less than ( 0 ) Zero or " LEFT EMPTY !"');
    } else if (this.downPayment > 90) {
      this.errorInfo = false;
      this.errorMessage = ('Down payment can not be more than ( 90% ) Ninety percent.');
    } else if (this.interestRate == null) {  // INTEREST RATE VALIDATION
      this.errorInfo = false;
      this.errorMessage = ('Interest rate can not be less / equal to ( 0 ) Zero or " LEFT EMPTY ! "');
    } else if (this.interestRate === '') {
      this.errorInfo = false;
      this.errorMessage = ('Interest rate can not be less / equal to ( 0 ) Zero or " LEFT EMPTY ! "');
    } else if (isNaN(this.interestRate)) {
      this.errorInfo = false;
      this.errorMessage = ('Please enter only numbers in " INTEREST RATE PER YEAR " field.');
    } else if (this.interestRate > 20) {
      this.errorInfo = false;
      this.errorMessage = ('Interest rate can not be more than ( 20% ) Twenty percent.');
    } else if (this.interestRate <= 0) {
      this.errorInfo = false;
      this.errorMessage = ('Interest rate can not be less / equal to ( 0 ) Zero or " LEFT EMPTY ! "');
    } else if (this.loanTerm == null) {  // LOAN TERM VALIDATION
      this.errorInfo = false;
      this.errorMessage = ('Loan term can only be from 1 to 50 and should not be " LEFT EMPTY ! "');
    } else if (this.loanTerm === '') {
      this.errorInfo = false;
      this.errorMessage = ('Loan term can only be from 1 to 50 and should not be " LEFT EMPTY ! "');
    } else if (!Number.isInteger(Number(this.loanTerm))) {
      this.errorInfo = false;
      this.errorMessage = ('Please enter only whole numbers from ( 1 to 50 ) in " LOAN TERM IN YEARS " field.');
    } else if (this.loanTerm < 1) {
      this.errorInfo = false;
      this.errorMessage = ('Loan term can only be from ( 1 to 50 ) and should not be " LEFT EMPTY ! "');
    } else if (this.loanTerm > 50) {
      this.errorInfo = false;
      this.errorMessage = ('Loan term can not be more than ( 50 ) Fifty years.');
    } else {
      this.hide = false;
      this.errorInfo = true;
      this.loanValue = Number(this.loanValue);
      this.downPayment = Number(this.downPayment);
      this.interestRate = Number(this.interestRate);
      this.loanTerm = Number(this.loanTerm);

      this.calcService.onReceivedFormData(this.hide, this.loanValue, this.downPayment,
        this.interestRate, this.loanTerm);
    }
  }

  resetCalculation() {
    this.hide = true;
    this.loanValue = '';
    this.downPayment = '';
    this.interestRate = '';
    this.loanTerm = '';

    this.calcService.onReceivedFormData(this.hide, this.loanValue, this.downPayment,
      this.interestRate, this.loanTerm);

  }
}



// WEBPACK FOOTER //
// D:/IT-Projects/Projects/amortization/amortization-v03.1.1/src/app/amort-form/amort-form.component.ts